import { render, staticRenderFns } from "./sl-extended-select.vue?vue&type=template&id=f5fc197e&scoped=true&"
import script from "./sl-extended-select.vue?vue&type=script&lang=js&"
export * from "./sl-extended-select.vue?vue&type=script&lang=js&"
import style0 from "./sl-extended-select.vue?vue&type=style&index=0&id=f5fc197e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fc197e",
  null
  
)

export default component.exports